"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tracks;

var _element = require("@wordpress/element");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

function Tracks(_ref) {
  let {
    tracks = []
  } = _ref;
  return tracks.map(track => {
    return (0, _element.createElement)("track", (0, _extends2.default)({
      key: track.src
    }, track));
  });
}
//# sourceMappingURL=tracks.js.map